import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal, Form, Input, Select, Button } from 'antd';
import {
  createAgentAction,
  listAgentsAction,
} from '../../../../store/actions/agents.action';
import { showToastError } from 'src/utilities/errortoast';

const { Option } = Select;
const { TextArea } = Input;

// Constants for agent fields
const AGENT_PRODUCTS = ['phone-triage', 'frontdesk'];

const AddNewAgent = ({ isOpen, setIsOpen, filterValue, orgUuid }) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [externalIdText, setExternalIdText] = useState('');

  const handleClose = () => {
    form.resetFields();
    setExternalIdText('');
    setIsOpen(false);
  };

  const handleSubmit = (values) => {
    if (!orgUuid) {
      showToastError('Organization UUID is required');
      return;
    }

    const payload = {
      name: values.name.trim(),
      product: values.product,
      external_id: externalIdText.trim(),
    };

    dispatch(
      createAgentAction(orgUuid, payload, () => {
        handleClose();
        dispatch(listAgentsAction(orgUuid, filterValue));
      })
    );
  };

  return (
    <Modal
      title="Add New Agent"
      open={isOpen}
      onCancel={handleClose}
      footer={null}
      width={600}
    >
      <Form form={form} layout="vertical" onFinish={handleSubmit}>
        <Form.Item
          name="name"
          label="Agent Name"
          rules={[
            { required: true, message: 'Please enter agent name' },
            { min: 2, message: 'Agent name must be at least 2 characters' },
            { max: 100, message: 'Agent name must not exceed 100 characters' },
          ]}
        >
          <Input placeholder="Enter agent name" maxLength={100} />
        </Form.Item>

        <Form.Item
          name="product"
          label="Product"
          rules={[{ required: true, message: 'Please select a product' }]}
        >
          <Select
            placeholder="Select product"
            allowClear
            showSearch
            className="w-full"
          >
            {AGENT_PRODUCTS.map((product) => (
              <Option key={product} value={product}>
                {product}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          name="external_id"
          label="External ID"
          rules={[
            { max: 500, message: 'External ID must not exceed 500 characters' },
          ]}
        >
          <Input
            value={externalIdText}
            onChange={(e) => setExternalIdText(e.target.value)}
            placeholder="Enter external ID (optional)"
            maxLength={500}
          />
        </Form.Item>

        <div className="flex justify-end">
          <Button onClick={handleClose} className="mr-2">
            Cancel
          </Button>
          <Button type="primary" htmlType="submit" disabled={!orgUuid}>
            Create Agent
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default AddNewAgent;
